import React from 'react';

// Bootstrap Components
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Educacion from '../../../../assets/images/education/image2.png';

const HeroSection = () => {
  return (
    <section className="hero-education" id="hero">
      <Container fluid="lg">
        <Row className="content">
          <Col className="hero-education__header">
            <span className="hero-education__chip">Educación</span>
            <h1 className="hero-education__header-text">
              Encuentra la propuesta educativa que mejor se adapte a tu grupo de
              amigas, institución, colectivo…
            </h1>
            <div className="hero-education__header-image">
              <img
                alt="Imagen de una charla realizada por Carolina Ackermann"
                src={Educacion}
                className=" image"
              />
              <span className="hero-education__header-tag">Educación</span>
            </div>
          </Col>
          <Col className="hero-education__def">
            <p className="hero-education__def-title">Educación sobre la perimenopausia y la menopausia</p>

            <div className="hero-education__def-text">
              <p className="hero-education__def-text--left">
              La educación sobre la perimenopausia y la menopausia es una práctica educativa activa que, desde una perspectiva feminista e interseccional, acompaña a las mujeres y a la comunidad en la comprensión y resignificación de estas etapas.
              </p>
              <p className="hero-education__def-text--right">
              Como educadora comunitaria en la Asociación de Cultura menstrual La Vida en Rojo, desarrollo y facilito procesos educativos sobre el ciclo vital de las mujeres, combinando conocimiento científico y dinámicas participativas.  
              </p>
            </div>
            
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
